'use client'
import React, {useEffect} from 'react';
import styled from "styled-components";
import {Container} from "react-bootstrap";
import reactHtmlParser from "react-html-parser";
import {Img} from "@/components/Img";
import {} from "@/styles/globalStyleVars";
import {AnimatePresence, motion} from 'framer-motion'
import ImageParallax from "@/components/ImageParallax";



const InnerBanner = ({img, text, title,data,imgMobile}) => {
    return (
        <StyledInnerBanner className='InnerBanner'>
            <Img banner={true} src={img} srcSm={imgMobile} alt={text ? text : 'Shanta Equity'} />
            <Container>
                <motion.div
                    initial={{opacity: 0, y: 100}}
                    animate={{opacity: 1, y: 0}}
                    transition={{ease: 'easeInOut', duration: 0.50}}
                >
                    <h1 className={`anim-active fade-up`}>{reactHtmlParser(text)}</h1>
                </motion.div>
            </Container>
        </StyledInnerBanner>
);
};

const StyledInnerBanner = styled.section`
padding-top: calc(500 / 1366 * 100%);
position: relative;
    overflow: hidden;
background-color: #DDD;

    &:after {
        content: '';
        position: absolute;
        background-color: rgba(0, 0, 0, 0.25);
        height: 100%;
        width: 100%;
        left: 0;
        top: 0;
    }

    .container {
        position: absolute;
        //height: 100%;
        //top: 0;
        margin: auto;
        left: 0;
        right: 0;
        bottom: 60px;
        z-index: 2;
        overflow: hidden;
    }

    h1 {
        left: 15px;
        color: #FFF;        
        z-index: 2;
        //text-align: center;
        text-transform: capitalize;
        font-size: 60px;
        line-height: 70px;
        
    }
    
    @media (max-width: 767px) {
      padding-top: calc(350 / 375 * 100%);
      .title {
        width: 50%;
        margin-bottom: 40px !important;
      }
      .container {
        bottom: 40px;
      }
      h1{
          font-size: 40px;
          line-height: 48px;
      }
    }
    @media(min-width: 1550px){
        h1{
            font-size: 64px;
            line-height: 72px;
        }
    }
`;

export default InnerBanner;
